export default {
    data:"data" ,

    // 位置 倒计时 
    location:null,
    countDown: 60, 
}